import { render, staticRenderFns } from "./active-calls.vue?vue&type=template&id=42506786&"
import script from "./active-calls.vue?vue&type=script&lang=js&"
export * from "./active-calls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports